import FormFieldElement from "../form-field-element";
import DOMElement from "../../../dom-element";

export default class CheckboxFieldElement extends FormFieldElement {
    constructor(props) {
        super(props);
    }

    _setProps() {
        super._setProps();

        this.type = 'checkbox';
        this.class = DOMElement.classListFrom('f-checkbox-field', this.class);
        this.labelTag = 'span';
        this.options = this.props.options || [];
    }

    _checkProps() {
        super._checkProps();

        if (!Array.isArray(this.options)) {
            throw new Error('CheckboxFieldElement: Options should be an array.');
        }

        this.options.forEach((option) => {
            if (typeof option !== 'object') {
                throw new Error('CheckboxFieldElement: Option should be an object.');
            }

            if (!option.value) {
                throw new Error('CheckboxFieldElement: Option value is not defined.');
            }

            if (!option.label) {
                throw new Error('CheckboxFieldElement: Option label is not defined.');
            }
        });
    }

    _initInput() {
        const inputAttributes = {
            'data-form': 'input'
        };

        if (this.inputId) {
            inputAttributes.id = this.inputId;
        }

        this.input = new DOMElement('div', {
            class: DOMElement.classListFrom('f-checkbox-input', this.inputClass),
            attributes: inputAttributes,
            children: this.options.map((option) => this._initCheckbox(option))
        });

        super._initInput();
    }

    _initCheckbox(config) {
        const checkboxInputAttributes = {
            name: this.name,
            type: 'checkbox',
            class: 'checkbox_input',
            value: config.value
        };

        if (config.disabled != null ? config.disabled : this.disabled) {
            checkboxInputAttributes.disabled = 'true';
        }

        if (config.checked) {
            checkboxInputAttributes.checked = 'true';
        }

        return new DOMElement('label', {
            class: 'checkbox',
            children: [
                new DOMElement('input', {
                    attributes: checkboxInputAttributes
                }),
                new DOMElement('span', {
                    class: 'checkbox_checkmark'
                }),
                new DOMElement('span', {
                    class: 'checkbox_label',
                    html: config.label
                })
            ]
        });
    }
}